module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_7042.5a5d5d76.png";